export { default } from './DistributionBarWidget';
